module.exports = __webpack_public_path__ + "media/widget/DateTime-aad92cd1.png";